import styled from "styled-components";

export const Nav = styled.div<{ scrolled: boolean }>`
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 1.5rem 0;
  background: ${({ scrolled, theme }) =>
    scrolled
      ? "transparent"
      : theme.palette.background};
  transition: background 0.3s ease;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  z-index: 2;
`;

